import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-exclusions',
    templateUrl: './exclusions.component.html',
    styleUrls: ['./exclusions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExclusionsComponent implements OnInit {
  status=false;
  constructor() { }

  ngOnInit() {
  }

}
